import type { PaymentMethod } from '../model/payment.types';

type PaymentMethodOption = {
    value: PaymentMethod;
    label: string;
    description?: string;
    disabled?: boolean;
};

export const paymentMethodOptions: PaymentMethodOption[] = [
    { value: 'CARD_ON_FILE', label: 'Card on file', disabled: true },
    { value: 'CASH', label: 'Cash' },
    { value: 'CHECK', label: 'Check' },
    {
        value: 'EXTERNAL_CARD',
        label: 'External card',
        description: 'Record a payment from external processor',
    },
];
